import { RootState } from "store/store";
export const selectMainAnaltytics = (state: RootState) => state.mainAnalytics;
export const selectMainAnalyticsData = (state: RootState) =>
  state.mainAnalytics.data;
export const selectMainAnalyticsLoading = (state: RootState) =>
  state.mainAnalytics.loading;
